import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Cours from "./pages/Cours";
import Planning from "./pages/Planning";
import Inscription from "./pages/Inscription";
import Galerie from "./pages/Galerie";
import Stages from "./pages/Stages";
import Contact from "./pages/Contact";
import DatesImportantes from "./pages/DatesImportantes";
import { Toaster } from "./components/ui/sonner";
import { DataProvider } from "./context/DataContext";
import { AuthProvider } from "./context/AuthContext";
import { ParentAuthProvider } from "./context/ParentAuthContext";

// Admin
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import RequireAuth from "./admin/RequireAuth";
import Dashboard from "./admin/Dashboard";
import { CoursesAdmin, TeachersAdmin, TarifsAdmin, TenuesAdmin, DatesAdmin, GalleryAdmin, GalleryCategoriesAdmin, InfosAdmin, CategoriesAdmin, BoardMembersAdmin, StagesAdmin } from "./admin/SimpleEditors";
import PlanningAdmin from "./admin/PlanningAdmin";
import ScheduleAdmin from "./admin/ScheduleAdmin";
import PricingTiersAdmin from "./admin/PricingTiersAdmin";
import HomeDancesAdmin from "./admin/HomeDancesAdmin";
import BroadcastAdmin from "./admin/BroadcastAdmin";
import SiteSettingsAdmin from "./admin/settings/SiteSettingsAdmin";
import FinanceSettingsAdmin from "./admin/settings/FinanceSettingsAdmin";
import AccountingAdmin from "./admin/AccountingAdmin";
import StudentsAdmin from "./admin/StudentsAdmin";
import LegalPagesAdmin from "./admin/LegalPagesAdmin";
import LegalPage from "./pages/LegalPage";
import { InscriptionsAdmin, ContactsAdmin } from "./admin/SubmissionsAdmin";
import { FamiliesAdmin, EnrollmentsAdmin, PaymentsAdmin } from "./admin/CrmAdmin";
import OrdersAdmin, { OrderDetailPage } from "./admin/OrdersAdmin";
import SepaDiagnosticAdmin from "./admin/SepaDiagnosticAdmin";
import EnrollmentsBySlotAdmin from "./admin/EnrollmentsBySlotAdmin";
import LevelRequestsAdmin from "./admin/LevelRequestsAdmin";
import AdminUsersAdmin from "./admin/AdminUsersAdmin";
import AttendanceAdmin from "./admin/AttendanceAdmin";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import ParentLogin from "./parent/ParentLogin";
import ParentForgotPassword from "./parent/ParentForgotPassword";
import ParentResetPassword from "./parent/ParentResetPassword";
import ParentLayout from "./parent/ParentLayout";
import ParentDashboard from "./parent/ParentDashboard";
import RequireParent from "./parent/RequireParent";
import { CartProvider } from "./context/CartContext";
import ShopGate from "./components/ShopGate";
import Boutique from "./pages/Boutique";
import BoutiqueProduit from "./pages/BoutiqueProduit";
import BoutiquePanier from "./pages/BoutiquePanier";
import BoutiqueSuccess from "./pages/BoutiqueSuccess";
import ParentShopOrders from "./parent/ParentShopOrders";
import ShopProductsAdmin from "./admin/ShopProductsAdmin";
import ShopPromoAdmin from "./admin/ShopPromoAdmin";
import ShopOrdersAdmin from "./admin/ShopOrdersAdmin";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ParentAuthProvider>
          <DataProvider>
          <CartProvider>
            <BrowserRouter>
            <Routes>
              {/* Public site */}
              <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="cours-tenues" element={<Cours />} />
                <Route path="planning-tarifs" element={<Planning />} />
                <Route path="inscription" element={<Inscription />} />
                <Route path="galerie" element={<Galerie />} />
                <Route path="stages" element={<Stages />} />
                <Route path="contact" element={<Contact />} />
                <Route path="boutique" element={<ShopGate><Boutique /></ShopGate>} />
                <Route path="boutique/panier" element={<ShopGate><BoutiquePanier /></ShopGate>} />
                <Route path="boutique/paiement-succes" element={<ShopGate><BoutiqueSuccess /></ShopGate>} />
                <Route path="boutique/:productId" element={<ShopGate><BoutiqueProduit /></ShopGate>} />
                <Route path="mentions-legales" element={<LegalPage slug="mentions-legales" />} />
                <Route path="politique-de-confidentialite" element={<LegalPage slug="politique-de-confidentialite" />} />
                <Route path="conditions-generales-utilisation" element={<LegalPage slug="conditions-generales-utilisation" />} />
                <Route path="cookies" element={<LegalPage slug="cookies" />} />
                <Route path="dates-importantes" element={<DatesImportantes />} />
              </Route>

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
                <Route index element={<Dashboard />} />
                <Route path="courses" element={<CoursesAdmin />} />
                <Route path="categories" element={<CategoriesAdmin />} />
                <Route path="teachers" element={<TeachersAdmin />} />
                <Route path="planning" element={<PlanningAdmin />} />
                <Route path="schedule" element={<ScheduleAdmin />} />
                <Route path="stages" element={<StagesAdmin />} />
                <Route path="pricing-tiers" element={<PricingTiersAdmin />} />
                <Route path="home-dances" element={<HomeDancesAdmin />} />
                <Route path="broadcast" element={<BroadcastAdmin />} />
                <Route path="tarifs" element={<TarifsAdmin />} />
                <Route path="tenues" element={<TenuesAdmin />} />
                <Route path="dates" element={<DatesAdmin />} />
                <Route path="gallery-categories" element={<GalleryCategoriesAdmin />} />
                <Route path="board-members" element={<BoardMembersAdmin />} />
                <Route path="gallery" element={<GalleryAdmin />} />
                <Route path="infos" element={<InfosAdmin />} />
                <Route path="families" element={<FamiliesAdmin />} />
                <Route path="students" element={<StudentsAdmin />} />
                <Route path="enrollments" element={<EnrollmentsAdmin />} />
                <Route path="orders" element={<OrdersAdmin />} />
                <Route path="orders/:orderId" element={<OrderDetailPage />} />
                <Route path="sepa-diagnostic" element={<SepaDiagnosticAdmin />} />
                <Route path="enrollments-by-slot" element={<EnrollmentsBySlotAdmin />} />
                <Route path="payments" element={<PaymentsAdmin />} />
                <Route path="level-requests" element={<LevelRequestsAdmin />} />
                <Route path="inscriptions" element={<InscriptionsAdmin />} />
                <Route path="contacts" element={<ContactsAdmin />} />
                <Route path="attendance" element={<AttendanceAdmin />} />
                <Route path="admins" element={<AdminUsersAdmin />} />
                <Route path="settings" element={<Navigate to="/admin/settings/site" replace />} />
                <Route path="settings/site" element={<SiteSettingsAdmin />} />
                <Route path="legal" element={<LegalPagesAdmin />} />
                <Route path="boutique/produits" element={<ShopProductsAdmin />} />
                <Route path="boutique/codes-promo" element={<ShopPromoAdmin />} />
                <Route path="boutique/commandes" element={<ShopOrdersAdmin />} />
                <Route path="settings/finance" element={<FinanceSettingsAdmin />} />
                <Route path="accounting" element={<AccountingAdmin />} />
              </Route>

              {/* Inscription payment callbacks */}
              <Route path="/inscription/paiement-succes" element={<PaymentSuccess />} />
              <Route path="/inscription/paiement-annule" element={<PaymentCancel />} />

              {/* Parent portal */}
              <Route path="/espace-famille/login" element={<ParentLogin />} />
              <Route path="/espace-famille/mot-de-passe-oublie" element={<ParentForgotPassword />} />
              <Route path="/espace-famille/reset" element={<ParentResetPassword />} />
              <Route path="/espace-famille" element={<RequireParent><ParentLayout /></RequireParent>}>
                <Route index element={<ParentDashboard />} />
                <Route path="boutique" element={<ParentShopOrders />} />
                {/* ajouter-cours désactivé temporairement — se fait via le BO */}
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
          </CartProvider>
          </DataProvider>
        </ParentAuthProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
